/**
 * Action caps for hangout decision prompts (mirrors text_worker getActionCap).
 */
export const getActionCap = (isPaidMembership) => (isPaidMembership ? 60 : 30);

/**
 * Among sprites in display order, return selection keys that would be truncated
 * by the worker (.filter selected then .slice(0, actionCap)).
 */
export const getTruncatedSelectionKeys = (sprites, selectedKeys, actionCap) => {
  const truncated = new Set();
  if (!Array.isArray(sprites) || !selectedKeys || !Number.isFinite(actionCap)) {
    return truncated;
  }

  let selectedRank = 0;
  for (const sprite of sprites) {
    const key = `${sprite.char_id}_${sprite.outfit_id}_${sprite.action_id}`;
    if (!selectedKeys.has(key)) continue;
    if (selectedRank >= actionCap) truncated.add(key);
    selectedRank += 1;
  }
  return truncated;
};

export const formatSpriteGalleryStatus = (selectedCount, totalCount, actionCap) =>
  `${selectedCount} / ${totalCount} selected (max ${actionCap})`;

export const isSpriteSelectionOverCap = (selectedCount, actionCap) =>
  Number(selectedCount) > Number(actionCap);
